import React from 'react'
// import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'
import App from './App'
import { APP_LAST_UPDATE } from './utils/constants'

global.appVer = APP_LAST_UPDATE

// ReactDOM.render(<App />, document.getElementById('root'))
createRoot(document.getElementById('root')).render(<App />)
